import { hexToRgb } from '../../../../utils/functions';

export default ({
  palette: { text },
  fonts,
  spacing,
  breakpoints: { down },
}) => ({
  accordionItem: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    color: text.primary,
    width: '100%',
    marginTop: spacing(9.5),
    minHeight: 0,
    '&:first-child': {
      marginTop: spacing(0),
    },
    '&::before': {
      display: 'none',
    },
    '& p': {
      opacity: 0.6,
      fontWeight: 300,
    },
    '&.Mui-expanded': {
      marginTop: spacing(9.5),
      minHeight: 0,
      '& p': {
        opacity: 1,
        fontWeight: 400,
      },
      [down('sm')]: {
        marginTop: spacing(7),
      },
      [down('xs')]: {
        marginTop: spacing(5),
      },
    },
    [down('sm')]: {
      marginTop: spacing(7),
    },
    [down('xs')]: {
      marginTop: spacing(5),
    },
  },
  accordionHeader: {
    padding: spacing(0),
    borderBottom: 'none',
    position: 'relative',
    minHeight: 0,
    '&.MuiAccordionSummary-root.Mui-expanded': {
      minHeight: 0,
    },
    '& .MuiAccordionSummary-content': {
      width: '100%',
      borderBottom: `2px solid rgba(${
        hexToRgb(text.primary)[0]
      },${hexToRgb(text.primary)[1]},${
        hexToRgb(text.primary)[2]
      }, 0.2)`,
      padding: spacing(0),
      margin: spacing(0),
      '&.Mui-expanded': {
        borderBottom: `2px solid ${text.primary}`,
      },
    },
    '& .MuiAccordionSummary-expandIcon': {
      position: 'absolute',
      top: 0,
      right: 0,
      borderBottom: 'none',
      marginRight: spacing(-1.5),
      transform: 'none',
      height: 42,
      width: 42,
      [down('sm')]: {
        height: '100%',
        top: 0,
        bottom: 0,
        right: 0,
      },
      [down('xs')]: {
        height: 36,
        width: 36,
        minHeight: '100%',
      },
      [down(325)]: {
        top: -3,
      },
    },
    [down('sm')]: {
      minHeight: 0,
    },
    [down('xs')]: {
      minHeight: 0,
    },
  },
  accordionHeaderText: {
    fontSize: fonts.size.xxxm,
    opacity: 0.9,
    padding: spacing(0, 3, 0, 0),
    [down('sm')]: {
      fontSize: fonts.size.xm - 1,
      padding: spacing(0, 3, 1, 0),
    },
    [down('xs')]: {
      fontSize: fonts.size.s,
    },
    [down(325)]: {
      fontSize: fonts.size.xs,
    },
  },
  faqNumber: {
    fontSize: 'inherit',
    opacity: 0.9,
    fontWeight: 'inherit',
    color: 'inherit',
    [down('xs')]: {
      display: 'none',
    },
  },
  description: {
    whiteSpace: 'pre-line',
    paddingLeft: spacing(2),
    maxWidth: 600,
    '& a': {
      color: text.primary,
      textDecoration: 'none',
      position: 'relative',
      '&::after': {
        position: 'absolute',
        left: 0,
        bottom: -3,
        height: 2,
        width: '100%',
        content: '""',
        opacity: 0.2,
        backgroundColor: text.primary,
      },
    },
    [down('xs')]: {
      fontSize: fonts.size.xxs,
    },
  },
  accordionDetails: {
    position: 'relative',
    marginTop: spacing(3),
    '&::before': {
      position: 'absolute',
      left: 0,
      top: 0,
      height: '100%',
      width: 6,
      content: '""',
      backgroundColor: text.primary,
      opacity: 0.2,
    },
  },
});
